import * as types from "./mutationTypes";

export default {
  [types.SET_CATEGORIES_TREE](state, categories) {
    state.categoriesTree = categories;
  },
  [types.CLEAR_CATEGORIES_TREE](state) {
    state.categoriesTree = null;
  },
  [types.SET_CATEGORIES](state, categories) {
    state.categories = categories;
  },
  [types.CLEAR_CATEGORIES](state) {
    state.categories = null;
  },
  [types.SET_CATEGORY](state, category) {
    state.category = category;
  },
  [types.CLEAR_CATEGORY](state) {
    state.category = null;
  },
  [types.SET_PARENT](state, parent) {
    state.category.parent_uuid = parent;
  },
  [types.SET_NAME](state, name) {
    state.category.name = name;
  },
  [types.SET_COLOR](state, color) {
    state.category.color = color;
  }
};
